<template>
  <div>
    <div class="flex flex-row items-center gap-[5px]">
      <span class="material-symbols-rounded text-error text-base">error</span>
      <p class="text-xs text-error font-medium">
        {{ errorMessage?.length ? errorMessage : defaultErrorMessage }}
      </p>
    </div>
    <div v-if="errorMessage === 'אתם נדרשים לאמת את האימייל שלכם כדי להכנס למערכת'">
      <button-text @click="goToConfirmEmailPage">לאימות המייל לחץ כאן</button-text>
    </div>
  </div>
</template>

<script>
import ButtonText from "@/components/Global/ButtonText.vue";

export default {
  name: "error-block",
  components: {ButtonText},
  props: {
    errorMessage: String,
  },
  data() {
    return {
      defaultErrorMessage: "יש כאן איזו טעות במייל או בסיסמה. בואו ננסה עוד פעם.",
    };
  },
  methods: {
    goToConfirmEmailPage() {
      this.$router.push("/send-email-verification");
    },
  }
};
</script>

<style>
</style>